/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../connect/v2/resources/error';
import './device';
import '../../connect/v2/common/sort';
import './application_type';
import './search_devices_query';
import './device_action';
import './supported_peripheral';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "GetDeviceRequest": {
                "fields": {
                  "deviceId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetDeviceResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "device": {
                    "type": ".squareup.connect.v2.Device",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ListDevicesRequest": {
                "fields": {
                  "cursor": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "sortOrder": {
                    "type": ".squareup.connect.v2.common.SortOrder",
                    "id": 2,
                    "rule": "optional",
                    "options": {
                      "default": "DESC"
                    }
                  },
                  "limit": {
                    "type": "int32",
                    "id": 3,
                    "rule": "optional",
                    "options": {
                      "default": 20
                    }
                  },
                  "locationId": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "deviceType": {
                    "type": ".squareup.connect.v2.DeviceAttributes.DeviceType",
                    "id": 5,
                    "rule": "optional",
                    "options": {
                      "default": "TERMINAL"
                    }
                  },
                  "applicationType": {
                    "type": ".squareup.connect.v2.ApplicationType",
                    "id": 6,
                    "rule": "optional",
                    "options": {
                      "default": "TERMINAL_API"
                    }
                  }
                }
              },
              "ListDevicesResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "devices": {
                    "type": ".squareup.connect.v2.Device",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "cursor": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "SearchDevicesRequest": {
                "fields": {
                  "query": {
                    "type": ".squareup.connect.v2.SearchDevicesQuery",
                    "id": 1,
                    "rule": "optional"
                  },
                  "cursor": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "limit": {
                    "type": "int32",
                    "id": 3,
                    "rule": "optional",
                    "options": {
                      "default": 20
                    }
                  }
                }
              },
              "SearchDevicesResponse": {
                "fields": {
                  "devices": {
                    "type": ".squareup.connect.v2.Device",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "cursor": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "totalCount": {
                    "type": "int32",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "DeleteDeviceRequest": {
                "fields": {
                  "deviceId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "DeleteDeviceResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "BatchDeleteDevicesRequest": {
                "fields": {
                  "searchDevicesFilter": {
                    "type": ".squareup.connect.v2.SearchDevicesFilter",
                    "id": 1,
                    "rule": "optional"
                  },
                  "deviceIds": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "BatchDeleteDevicesResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "BatchRetrieveDevicesRequest": {
                "fields": {
                  "deviceIds": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "BatchRetrieveDevicesResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "devices": {
                    "type": ".squareup.connect.v2.Device",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "SendDeviceActionRequest": {
                "fields": {
                  "deviceIds": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "targetApplicationTypes": {
                    "type": ".squareup.connect.v2.ApplicationType",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "deviceAction": {
                    "type": ".squareup.connect.v2.DeviceAction",
                    "id": 3,
                    "rule": "optional"
                  },
                  "personToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "SendDeviceActionResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "deviceActionId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "failedDeviceIds": {
                    "type": "string",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              },
              "UpdateDeviceActionRequest": {
                "fields": {
                  "deviceId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "deviceActionId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "status": {
                    "type": ".squareup.connect.v2.DeviceActionStatus",
                    "id": 3,
                    "rule": "optional"
                  },
                  "failureReason": {
                    "type": ".squareup.connect.v2.DeviceActionFailureReason",
                    "id": 4,
                    "rule": "optional"
                  },
                  "personToken": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "failureReasonDetails": {
                    "type": ".squareup.connect.v2.DeviceActionFailureReasonDetails",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              },
              "UpdateDeviceActionResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "ListDeviceActionsRequest": {
                "fields": {
                  "cursor": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "limit": {
                    "type": "int32",
                    "id": 2,
                    "rule": "optional",
                    "options": {
                      "default": 20
                    }
                  },
                  "sortOrder": {
                    "type": ".squareup.connect.v2.common.SortOrder",
                    "id": 3,
                    "rule": "optional",
                    "options": {
                      "default": "DESC"
                    }
                  },
                  "deviceId": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "ListDeviceActionsResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "deviceAction": {
                    "type": ".squareup.connect.v2.DeviceAction",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "cursor": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "RetrieveDeviceActionSnapshotsRequest": {
                "fields": {
                  "deviceId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "deviceActionId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "RetrieveDeviceActionSnapshotsResponse": {
                "fields": {
                  "deviceActionSnapshots": {
                    "type": ".squareup.connect.v2.DeviceActionSnapshot",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "UpdateThirdPartyDeviceLocationRequest": {
                "fields": {
                  "deviceId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "locationIds": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "UpdateThirdPartyDeviceLocationResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "UpdateSyncHubConfigurationRequest": {
                "fields": {
                  "action": {
                    "type": ".squareup.connect.v2.UpdateSyncHubConfigurationRequest.Action",
                    "id": 1,
                    "rule": "optional"
                  },
                  "locationId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "localHubHostDeviceId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "merchantId": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Action": {
                    "values": {
                      "ACTION_UNKNOWN": 0,
                      "ELECT_LOCAL_HUB_HOST": 1,
                      "CLEAR_LOCAL_HUB_HOST": 2
                    }
                  }
                }
              },
              "UpdateSyncHubConfigurationResponse": {
                "fields": {
                  "result": {
                    "type": ".squareup.connect.v2.UpdateSyncHubConfigurationResponse.Result",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "Result": {
                    "values": {
                      "RESULT_UNKNOWN": 0,
                      "SUCCESS": 1
                    }
                  }
                }
              },
              "GetSyncHubConfigurationRequest": {
                "fields": {
                  "locationId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetSyncHubConfigurationResponse": {
                "fields": {
                  "syncHubDetails": {
                    "type": ".squareup.connect.v2.PairWithSyncHubDetails",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "ListSupportedPeripheralsRequest": {
                "fields": {}
              },
              "ListSupportedPeripheralsResponse": {
                "fields": {
                  "peripherals": {
                    "type": ".squareup.connect.v2.SupportedPeripheral",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "DevicesService": {
                "methods": {
                  "GetDevice": {
                    "requestType": ".squareup.connect.v2.GetDeviceRequest",
                    "responseType": ".squareup.connect.v2.GetDeviceResponse"
                  },
                  "ListDevices": {
                    "requestType": ".squareup.connect.v2.ListDevicesRequest",
                    "responseType": ".squareup.connect.v2.ListDevicesResponse"
                  },
                  "SearchDevices": {
                    "requestType": ".squareup.connect.v2.SearchDevicesRequest",
                    "responseType": ".squareup.connect.v2.SearchDevicesResponse"
                  },
                  "DeleteDevice": {
                    "requestType": ".squareup.connect.v2.DeleteDeviceRequest",
                    "responseType": ".squareup.connect.v2.DeleteDeviceResponse"
                  },
                  "BatchDeleteDevices": {
                    "requestType": ".squareup.connect.v2.BatchDeleteDevicesRequest",
                    "responseType": ".squareup.connect.v2.BatchDeleteDevicesResponse"
                  },
                  "BatchRetrieveDevices": {
                    "requestType": ".squareup.connect.v2.BatchRetrieveDevicesRequest",
                    "responseType": ".squareup.connect.v2.BatchRetrieveDevicesResponse"
                  },
                  "SendDeviceAction": {
                    "requestType": ".squareup.connect.v2.SendDeviceActionRequest",
                    "responseType": ".squareup.connect.v2.SendDeviceActionResponse"
                  },
                  "UpdateDeviceAction": {
                    "requestType": ".squareup.connect.v2.UpdateDeviceActionRequest",
                    "responseType": ".squareup.connect.v2.UpdateDeviceActionResponse"
                  },
                  "ListDeviceActions": {
                    "requestType": ".squareup.connect.v2.ListDeviceActionsRequest",
                    "responseType": ".squareup.connect.v2.ListDeviceActionsResponse"
                  },
                  "RetrieveDeviceActionSnapshots": {
                    "requestType": ".squareup.connect.v2.RetrieveDeviceActionSnapshotsRequest",
                    "responseType": ".squareup.connect.v2.RetrieveDeviceActionSnapshotsResponse"
                  },
                  "UpdateThirdPartyDeviceLocation": {
                    "requestType": ".squareup.connect.v2.UpdateThirdPartyDeviceLocationRequest",
                    "responseType": ".squareup.connect.v2.UpdateThirdPartyDeviceLocationResponse"
                  },
                  "UpdateSyncHubConfiguration": {
                    "requestType": ".squareup.connect.v2.UpdateSyncHubConfigurationRequest",
                    "responseType": ".squareup.connect.v2.UpdateSyncHubConfigurationResponse"
                  },
                  "GetSyncHubConfiguration": {
                    "requestType": ".squareup.connect.v2.GetSyncHubConfigurationRequest",
                    "responseType": ".squareup.connect.v2.GetSyncHubConfigurationResponse"
                  },
                  "ListSupportedPeripherals": {
                    "requestType": ".squareup.connect.v2.ListSupportedPeripheralsRequest",
                    "responseType": ".squareup.connect.v2.ListSupportedPeripheralsResponse"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.GetDeviceRequest && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.GetDeviceResponse && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.ListDevicesRequest && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.ListDevicesResponse && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.SearchDevicesRequest && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.SearchDevicesResponse && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeleteDeviceRequest && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeleteDeviceResponse && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.BatchDeleteDevicesRequest && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.BatchDeleteDevicesResponse && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.BatchRetrieveDevicesRequest && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.BatchRetrieveDevicesResponse && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.SendDeviceActionRequest && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.SendDeviceActionResponse && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.UpdateDeviceActionRequest && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.UpdateDeviceActionResponse && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.ListDeviceActionsRequest && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.ListDeviceActionsResponse && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.RetrieveDeviceActionSnapshotsRequest && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.RetrieveDeviceActionSnapshotsResponse && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.UpdateThirdPartyDeviceLocationRequest && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.UpdateThirdPartyDeviceLocationResponse && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.UpdateSyncHubConfigurationRequest && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.UpdateSyncHubConfigurationRequest?.nested?.Action && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.UpdateSyncHubConfigurationResponse && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.UpdateSyncHubConfigurationResponse?.nested?.Result && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.GetSyncHubConfigurationRequest && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.GetSyncHubConfigurationResponse && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.ListSupportedPeripheralsRequest && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.ListSupportedPeripheralsResponse && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DevicesService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE GetDeviceRequest @ squareup/devices/external/devices_service.proto at 22:1
 */
export const GetDeviceRequest = $root.lookupType('squareup.connect.v2.GetDeviceRequest');
fixType(GetDeviceRequest);
Builder.createAndAttachToType(GetDeviceRequest);
/**
 * SOURCE GetDeviceResponse @ squareup/devices/external/devices_service.proto at 31:1
 */
export const GetDeviceResponse = $root.lookupType('squareup.connect.v2.GetDeviceResponse');
fixType(GetDeviceResponse);
Builder.createAndAttachToType(GetDeviceResponse);
/**
 * SOURCE ListDevicesRequest @ squareup/devices/external/devices_service.proto at 45:1
 */
export const ListDevicesRequest = $root.lookupType('squareup.connect.v2.ListDevicesRequest');
fixType(ListDevicesRequest);
Builder.createAndAttachToType(ListDevicesRequest);
/**
 * SOURCE ListDevicesResponse @ squareup/devices/external/devices_service.proto at 93:1
 */
export const ListDevicesResponse = $root.lookupType('squareup.connect.v2.ListDevicesResponse');
fixType(ListDevicesResponse);
Builder.createAndAttachToType(ListDevicesResponse);
/**
 * SOURCE SearchDevicesRequest @ squareup/devices/external/devices_service.proto at 114:1
 */
export const SearchDevicesRequest = $root.lookupType('squareup.connect.v2.SearchDevicesRequest');
fixType(SearchDevicesRequest);
Builder.createAndAttachToType(SearchDevicesRequest);
/**
 * SOURCE SearchDevicesResponse @ squareup/devices/external/devices_service.proto at 126:1
 */
export const SearchDevicesResponse = $root.lookupType('squareup.connect.v2.SearchDevicesResponse');
fixType(SearchDevicesResponse);
Builder.createAndAttachToType(SearchDevicesResponse);
/**
 * SOURCE DeleteDeviceRequest @ squareup/devices/external/devices_service.proto at 141:1
 */
export const DeleteDeviceRequest = $root.lookupType('squareup.connect.v2.DeleteDeviceRequest');
fixType(DeleteDeviceRequest);
Builder.createAndAttachToType(DeleteDeviceRequest);
/**
 * SOURCE DeleteDeviceResponse @ squareup/devices/external/devices_service.proto at 147:1
 */
export const DeleteDeviceResponse = $root.lookupType('squareup.connect.v2.DeleteDeviceResponse');
fixType(DeleteDeviceResponse);
Builder.createAndAttachToType(DeleteDeviceResponse);
/**
 * SOURCE BatchDeleteDevicesRequest @ squareup/devices/external/devices_service.proto at 156:1
 */
export const BatchDeleteDevicesRequest = $root.lookupType('squareup.connect.v2.BatchDeleteDevicesRequest');
fixType(BatchDeleteDevicesRequest, {
  deviceIds: {
    required: true,
    notEmpty: true
  }
});
Builder.createAndAttachToType(BatchDeleteDevicesRequest);
/**
 * SOURCE BatchDeleteDevicesResponse @ squareup/devices/external/devices_service.proto at 174:1
 */
export const BatchDeleteDevicesResponse = $root.lookupType('squareup.connect.v2.BatchDeleteDevicesResponse');
fixType(BatchDeleteDevicesResponse);
Builder.createAndAttachToType(BatchDeleteDevicesResponse);
/**
 * SOURCE BatchRetrieveDevicesRequest @ squareup/devices/external/devices_service.proto at 183:1
 */
export const BatchRetrieveDevicesRequest = $root.lookupType('squareup.connect.v2.BatchRetrieveDevicesRequest');
fixType(BatchRetrieveDevicesRequest, {
  deviceIds: {
    required: true,
    notEmpty: true
  }
});
Builder.createAndAttachToType(BatchRetrieveDevicesRequest);
/**
 * SOURCE BatchRetrieveDevicesResponse @ squareup/devices/external/devices_service.proto at 196:1
 */
export const BatchRetrieveDevicesResponse = $root.lookupType('squareup.connect.v2.BatchRetrieveDevicesResponse');
fixType(BatchRetrieveDevicesResponse);
Builder.createAndAttachToType(BatchRetrieveDevicesResponse);
/**
 * SOURCE SendDeviceActionRequest @ squareup/devices/external/devices_service.proto at 210:1
 */
export const SendDeviceActionRequest = $root.lookupType('squareup.connect.v2.SendDeviceActionRequest');
fixType(SendDeviceActionRequest, {
  deviceIds: {
    required: true,
    notEmpty: true
  }
});
Builder.createAndAttachToType(SendDeviceActionRequest);
/**
 * SOURCE SendDeviceActionResponse @ squareup/devices/external/devices_service.proto at 233:1
 */
export const SendDeviceActionResponse = $root.lookupType('squareup.connect.v2.SendDeviceActionResponse');
fixType(SendDeviceActionResponse);
Builder.createAndAttachToType(SendDeviceActionResponse);
/**
 * SOURCE UpdateDeviceActionRequest @ squareup/devices/external/devices_service.proto at 243:1
 */
export const UpdateDeviceActionRequest = $root.lookupType('squareup.connect.v2.UpdateDeviceActionRequest');
fixType(UpdateDeviceActionRequest, {
  deviceId: {
    required: true,
    notEmpty: true
  },
  deviceActionId: {
    required: true,
    notEmpty: true
  }
});
Builder.createAndAttachToType(UpdateDeviceActionRequest);
/**
 * SOURCE UpdateDeviceActionResponse @ squareup/devices/external/devices_service.proto at 267:1
 */
export const UpdateDeviceActionResponse = $root.lookupType('squareup.connect.v2.UpdateDeviceActionResponse');
fixType(UpdateDeviceActionResponse);
Builder.createAndAttachToType(UpdateDeviceActionResponse);
/**
 * SOURCE ListDeviceActionsRequest @ squareup/devices/external/devices_service.proto at 276:1
 */
export const ListDeviceActionsRequest = $root.lookupType('squareup.connect.v2.ListDeviceActionsRequest');
fixType(ListDeviceActionsRequest, {
  deviceId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ListDeviceActionsRequest);
/**
 * SOURCE ListDeviceActionsResponse @ squareup/devices/external/devices_service.proto at 318:1
 */
export const ListDeviceActionsResponse = $root.lookupType('squareup.connect.v2.ListDeviceActionsResponse');
fixType(ListDeviceActionsResponse);
Builder.createAndAttachToType(ListDeviceActionsResponse);
/**
 * SOURCE RetrieveDeviceActionSnapshotsRequest @ squareup/devices/external/devices_service.proto at 339:1
 */
export const RetrieveDeviceActionSnapshotsRequest = $root.lookupType('squareup.connect.v2.RetrieveDeviceActionSnapshotsRequest');
fixType(RetrieveDeviceActionSnapshotsRequest, {
  deviceId: {
    required: true,
    notEmpty: true
  },
  deviceActionId: {
    required: true,
    notEmpty: true
  }
});
Builder.createAndAttachToType(RetrieveDeviceActionSnapshotsRequest);
/**
 * SOURCE RetrieveDeviceActionSnapshotsResponse @ squareup/devices/external/devices_service.proto at 355:1
 */
export const RetrieveDeviceActionSnapshotsResponse = $root.lookupType('squareup.connect.v2.RetrieveDeviceActionSnapshotsResponse');
fixType(RetrieveDeviceActionSnapshotsResponse);
Builder.createAndAttachToType(RetrieveDeviceActionSnapshotsResponse);
/**
 * SOURCE UpdateThirdPartyDeviceLocationRequest @ squareup/devices/external/devices_service.proto at 366:1
 */
export const UpdateThirdPartyDeviceLocationRequest = $root.lookupType('squareup.connect.v2.UpdateThirdPartyDeviceLocationRequest');
fixType(UpdateThirdPartyDeviceLocationRequest, {
  deviceId: {
    required: true,
    notEmpty: true
  }
});
Builder.createAndAttachToType(UpdateThirdPartyDeviceLocationRequest);
/**
 * SOURCE UpdateThirdPartyDeviceLocationResponse @ squareup/devices/external/devices_service.proto at 383:1
 */
export const UpdateThirdPartyDeviceLocationResponse = $root.lookupType('squareup.connect.v2.UpdateThirdPartyDeviceLocationResponse');
fixType(UpdateThirdPartyDeviceLocationResponse);
Builder.createAndAttachToType(UpdateThirdPartyDeviceLocationResponse);
/**
 * SOURCE UpdateSyncHubConfigurationRequest @ squareup/devices/external/devices_service.proto at 392:1
 */
export const UpdateSyncHubConfigurationRequest = $root.lookupType('squareup.connect.v2.UpdateSyncHubConfigurationRequest');
fixType(UpdateSyncHubConfigurationRequest, {
  action: {
    required: true
  },
  locationId: {
    required: true,
    notEmpty: true
  },
  merchantId: {
    required: true,
    notEmpty: true
  }
});
Builder.createAndAttachToType(UpdateSyncHubConfigurationRequest);
/**
 * SOURCE Action @ squareup/devices/external/devices_service.proto at 393:3
 */
UpdateSyncHubConfigurationRequest.Action = $root.lookupEnum('squareup.connect.v2.UpdateSyncHubConfigurationRequest.Action').values;
/**
 * SOURCE UpdateSyncHubConfigurationResponse @ squareup/devices/external/devices_service.proto at 428:1
 */
export const UpdateSyncHubConfigurationResponse = $root.lookupType('squareup.connect.v2.UpdateSyncHubConfigurationResponse');
fixType(UpdateSyncHubConfigurationResponse);
Builder.createAndAttachToType(UpdateSyncHubConfigurationResponse);
/**
 * SOURCE Result @ squareup/devices/external/devices_service.proto at 429:3
 */
UpdateSyncHubConfigurationResponse.Result = $root.lookupEnum('squareup.connect.v2.UpdateSyncHubConfigurationResponse.Result').values;
/**
 * SOURCE GetSyncHubConfigurationRequest @ squareup/devices/external/devices_service.proto at 440:1
 */
export const GetSyncHubConfigurationRequest = $root.lookupType('squareup.connect.v2.GetSyncHubConfigurationRequest');
fixType(GetSyncHubConfigurationRequest, {
  locationId: {
    required: true,
    notEmpty: true
  }
});
Builder.createAndAttachToType(GetSyncHubConfigurationRequest);
/**
 * SOURCE GetSyncHubConfigurationResponse @ squareup/devices/external/devices_service.proto at 451:1
 */
export const GetSyncHubConfigurationResponse = $root.lookupType('squareup.connect.v2.GetSyncHubConfigurationResponse');
fixType(GetSyncHubConfigurationResponse);
Builder.createAndAttachToType(GetSyncHubConfigurationResponse);
/**
 * SOURCE ListSupportedPeripheralsRequest @ squareup/devices/external/devices_service.proto at 460:1
 */
export const ListSupportedPeripheralsRequest = $root.lookupType('squareup.connect.v2.ListSupportedPeripheralsRequest');
fixType(ListSupportedPeripheralsRequest);
Builder.createAndAttachToType(ListSupportedPeripheralsRequest);
/**
 * SOURCE ListSupportedPeripheralsResponse @ squareup/devices/external/devices_service.proto at 464:1
 */
export const ListSupportedPeripheralsResponse = $root.lookupType('squareup.connect.v2.ListSupportedPeripheralsResponse');
fixType(ListSupportedPeripheralsResponse);
Builder.createAndAttachToType(ListSupportedPeripheralsResponse);
/**
 * --
 * External service for developers view Device data
 * --
 *
 * SOURCE DevicesService @ squareup/devices/external/devices_service.proto at 475:1
 */
export const DevicesService = $root.lookupService('squareup.connect.v2.DevicesService');